<template>
  <div class="custom">
    <template v-if="!isCustomExcel">
      <div class="excel-row" ref="scrollRow" :style="{width: isScrollY ? `calc(100% - ${scrollStyle.width})` : ''}">
        <div class="scroll-row">
          <div class="selection" :style="{ width: getWidth('', 'sel') }" :class="isNumFixed ? 'fixed-selection-num' : ''">
            <el-checkbox :disabled="listData.length === 0" v-model="isCheckAll" @change="checkAll"></el-checkbox>
          </div>
          <div class="serialNumber" v-if="tableStyleField.isSerialNumber" :style="{ width: getWidth('', 'num') }">
            <div :style="[listStyleConfig.titleConfig, { textAlign: 'center' }]">
              序号
            </div>
          </div>
          <div ref="excelRow" class="excel-row-item" :style="{ paddingRight: isAppenTodo ? todoWidth + 'px' : '' }"></div>
        </div>
        <div class="todo" v-if="isAppenTodo" :class="isScrollX && !isScrollXbuttom && tableStyleField.tableWidth === 'scroll' ? 'scroll-todo' : 'scroll-seize-aseat'" :style="{ width: todoWidth + 'px', right: isScrollY ? '6px' : '0' }">
          <div :style="[listStyleConfig.titleConfig, { textAlign: 'center' }]">操作</div>
        </div>
      </div>
    </template>
    <div class="fixed-right-patch" v-if="isScrollY && isAppenTodo" :style="scrollStyle"></div>
  </div>
</template>

<script>
import { parseWidth, generateHTMLTableWithWidth, getScrollbarWidth } from './utils'
export default {
// 组件名称
name: 'customRow',
// 组件状态值
data () {
  return {
    isScrollY: true,
    isScrollX: false,
    isScrollXbuttom: false,
    scrollStyle: {},
    isCheckAll: false
  }
},
props: {
  todoWidth: {
    type: Number,
    default: 60
  },
  tabelColRef: {
    type: Array,
    default: () => ([])
  },
  checkSyllable: {
    type: Array,
    default: ()=>([])
  },
  titleRowConfig: {
    type: Object,
    default: ()=>({})
  },
  tableRef: {
    type: Object,
    default: ()=>({})
  },
  tableStyleField: {
    type: Object,
    default: ()=>({})
  },
  listStyleConfig: {
    type: Object,
    default: ()=>({})
  },
  clickEffect: {
    type: Object,
    default: ()=>({})
  },
  listData: {
    type: Array,
    default: ()=>([])
  },
  filedWidthList: {
    type: Array,
    default: ()=>([])
  },
  isNumFixed: {
    type: Boolean,
    default: false
  },
  isAppenTodo: {
    type: Boolean,
    default: false
  }
},
// 计算属性
computed: {
  isFixed () {
    return this.tableStyleField.tableWidth === 'fixed'
  },
  isCustomExcel () {
    const config = this.titleRowConfig
    const flag = Object.keys(config).length === 0
    return flag
  },
  tableWidth() {
    const el = document.getElementsByClassName('custom-table-title')[0]
    let w = 0
    if (el) {
      w = el.getBoundingClientRect().width
    }
    return w
  },
  colsTotalWidth () {
    const cols = this.tabelColRef || []
    const widthList = []
    let total = 0
    for (const ele of cols) {
      const id = ele.columnId
      const col = document.getElementsByName(id)[0]
      if (col) {
        const width = col.getAttribute('width')
        total += +width
        widthList.push(total)
      }
    }
    return widthList
  }
},
// 组件方法
methods: {
  init(){
    this.$nextTick(() => {
      const ref = this.tableRef
      const bodyWrapper = ref.bodyWrapper
      if (!ref.$el) return
      const bodyHeight = ref.$el.getBoundingClientRect().height
      const body = ref.bodyWrapper.querySelector('.el-table__body');
      const scrollY = body.offsetHeight > bodyHeight
      this.isScrollY = scrollY
      const scrollW = getScrollbarWidth()
      const style = {
        width: scrollW + 'px'
      }
      this.scrollStyle = style
      bodyWrapper.addEventListener('scroll', this.onScroll, { passive: true })
      if (ref.$el) {
        const tableWidth = ref.$el.clientWidth
        let bodyMinWidth = 0
        this.tabelColRef.forEach((column) => {
          bodyMinWidth += column.width || column.minWidth || 80
        })
        if (bodyMinWidth <= tableWidth) {
          this.isScrollX = false
        } else {
          this.isScrollX = true
        }
      }
      this.createdExcelAfter()
    })
  },
  checkAll() {
    this.tableRef.toggleAllSelection()
  },
  onScroll () {
    const { scrollLeft, scrollWidth, clientWidth } = this.tableRef.bodyWrapper
    const ref = this.$refs.scrollRow
    
    ref.scrollLeft = scrollLeft
    if (clientWidth + scrollLeft === scrollWidth && this.isScrollXbuttom === false) {
      this.isScrollXbuttom = true
    } else if (this.isScrollXbuttom === true) {
      this.isScrollXbuttom = false
    }
  },
  createdExcelAfter () {
    // 创建成功之后开始渲染表格
    const data = this.titleRowConfig.data
    let tableWidth = this.tableWidth - 40
    if (this.clickEffect.todoNav === 'open') {
      tableWidth -= this.todoWidth
    }
    if (this.isScrollY) {
      tableWidth -= getScrollbarWidth()
    }
    const { html, elTableW } = generateHTMLTableWithWidth(data, {
      tableWidth: tableWidth,
      titleStyleConfig: this.listStyleConfig.titleConfig,
      tableStyleField: this.tableStyleField,
      filedWidthList: this.filedWidthList,
      colsTotalWidth: this.colsTotalWidth,
      checkSyllable: this.checkSyllable,
      isGetWidth: true,
    })
    if (elTableW && elTableW.length === this.checkSyllable.length) {
      for (const key in this.checkSyllable) {
        const w = elTableW[key]
        // eslint-disable-next-line vue/no-mutating-props
        this.checkSyllable[key].w = w
      }
    }
    const el = this.$refs.excelRow
    if (el) {
      el.innerHTML = html
    }
  },
  getWidth (item, type) {
    let w = ''
    if (type === 'sel') {
      w = 40 + 'px'
    } else if (type === 'num') {
      w = (this.tableStyleField.idxWidth || 50) + 'px'
    } else {
      if (this.tableStyleField.tableWidth === 'scroll') {
        w = item.w + 'px'
      } else {
        const val = this.tabelColRef.find(c => c.prop === item.title)
        if (val) {
          const id = val.columnId
          const col = document.getElementsByName(id)[0]
          if (col) {
            const width = col.getAttribute('width')
            console.log(width,'widthwidth');
            
            w = Number(width) + 'px'
          }
        } else {
          w = parseWidth(parseWidth(item.percentageW) / 100 * (this.tableWidth + 1)) + 'px'
        }
      }
    }
    return w
  },
}
}
</script>

<style scoped lang="scss">
.custom {
position: relative;
overflow: hidden;
&:hover {
  .row-model {
    display: inline-block;
  }
}
.scroll-todo {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
}
.row-model {
  position: absolute;
  inset: 0;
  background-color: #0000008d;
  display: none;
  .iconbianji {
    color: #fff;
    display: inline-block;
    cursor: pointer;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    &:hover {
      color: #4e86ff;
    }
  }
}
.scroll-row {
  display: flex;
  position: relative;
  min-height: 34px;
  height: fit-content;
  width: max-content;
  // overflow: hidden;
}
.excel-row {
  background-color: rgb(248, 249, 251);
  box-sizing: border-box;
  display: flex;
  // position: relative;
  min-height: 34px;
  height: fit-content;
  overflow: hidden;
  &-item {
    flex: 1;
    // overflow: hidden;
  }
  .excel-table {
    td {
      user-select: none;
    }
  }
  .serialNumber {
    display: flex;
    align-items: center;
    border-left: solid 1px #EBEEF5;
    border-top: solid 1px #EBEEF5;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .selection {
    box-sizing: border-box;
    user-select: none;
    padding: 0 10px;
    flex-shrink: 0;
    min-height: 34px;
    border-left: solid 1px #EBEEF5;
    border-top: solid 1px #EBEEF5;
    overflow: hidden;
    display: flex;
    align-items: center;
    background-color: #f8f9fb;
  }
  .fixed-selection-num {
    position: sticky;
    left: 0;
  }
  .todo {
    box-sizing: border-box;
    user-select: none;
    padding: 0 10px;
    flex-shrink: 0;
    overflow: hidden;
    min-height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: solid 1px #EBEEF5;
    border-top: solid 1px #EBEEF5;
    background-color: rgb(248, 249, 251);
    position: absolute;
    height: 100%;
  }
}
.fixed-right-patch {
  background-color: #fff;
  border-top: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  position: absolute;
  right: 0;
  top: 0;
  height: -webkit-fill-available;
  width: 6px;
  box-sizing: border-box;
}
}

</style>
